export const random = (min, max) => Math.floor(Math.random() * (max - min)) + min;
